import { CERelationshipAttributeAttributesBase } from './ce-relationship-attribute-attributes-base'


export class CERelationshipAttributeAttributes extends CERelationshipAttributeAttributesBase {

}